import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: "root",
})
export class LoadingService {
    
    private loadingSubject = new BehaviorSubject<boolean>(false);
    loading$ = this.loadingSubject.asObservable();

    private loadingRoutesSubject = new BehaviorSubject<boolean>(false);
    loadingRoutes$ = this.loadingRoutesSubject.asObservable();

    loadingOn() {
        this.loadingSubject.next(true);
    }

    loadingOff() {
        this.loadingSubject.next(false);
    }

    loadingRoutesOn() {
        this.loadingSubject.next(true);
    }

    loadingRoutesOff() {
        this.loadingSubject.next(false);
    }
}